module.exports = __webpack_public_path__ + "assets/static/media/logo-recruitfirst.0a79ac9d.png";